import React, { useEffect, useState } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { styled, Button } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import PageHeader from '../../../components/PageHeader';
import StaffDetail from '../../../components/StaffDetail';
import PersonDetail from '../../../components/PersonDetail';
import { api } from '../../../api';
import { Person } from '../../../schema/person';

const PersonDetailPage: React.FC = () => {
  const { person_id } = useParams();
  const [isStaff, setIsStaff] = useState<boolean>(false);

  useEffect(() => {
    if (person_id) {
      api
        .get<Person>(`/person/${person_id}`)
        .then((res) => {
          const { data } = res;
          setIsStaff(data.person_type.is_staff);
        })
        .catch((res) => res.json());
    }
  }, [person_id]);

  return (
    <RootContainer>
      <PageHeader text={isStaff ? 'ข้อมูลบุคลากร' : 'ข้อมูลบุคคล'} />
      <Button component={Link} to="/person" sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        บุคคลในระบบ
      </Button>
      {isStaff ? <StaffDetail person_id={person_id} /> : <PersonDetail person_id={person_id} />}
    </RootContainer>
  );
};

export default PersonDetailPage;

const RootContainer = styled('div')`
  padding: 24px;
`;
